// Arabic strings for the redesigned Closing (end-of-day) analytics workspace
// (components/Reports/ClosingWorkspace).
const trans = {
  // Page + tabs chrome
  Closing: "الإغلاق",
  "End-of-day summary of orders, payments and products closed.":
    "ملخّص نهاية اليوم للطلبات والمدفوعات والمنتجات المُغلقة.",
  "Totals, payment mix, order status and sales by hour for the window.":
    "الإجماليات وتوزيع المدفوعات وحالة الطلبات والمبيعات حسب الساعة للفترة.",
  "Actual payments recorded, by method and paid status.":
    "المدفوعات الفعلية المُسجّلة، حسب الطريقة وحالة السداد.",
  "Products sold in the window, by order status.": "المنتجات المباعة خلال الفترة، حسب حالة الطلب.",

  // Custom filter bar
  "Order status": "حالة الطلب",
  "All statuses": "جميع الحالات",
  "All stores": "جميع المتاجر",
  "All users": "جميع المستخدمين",
  "External order sources": "مصادر الطلبات الخارجية",

  // Summary KPIs + hints
  "Total sales": "إجمالي المبيعات",
  "Gross order value rung up": "إجمالي قيمة الطلبات المُسجّلة",
  "Orders in the closing window": "الطلبات في فترة الإغلاق",
  "Gross revenue": "إجمالي الإيرادات",
  "Total sales minus product & delivery cost (COGS).":
    "إجمالي المبيعات ناقص تكلفة المنتج والتوصيل (تكلفة البضاعة المباعة).",
  "Sales minus product & delivery cost (refunds excluded)":
    "المبيعات ناقص تكلفة المنتج والتوصيل (باستثناء المبالغ المستردة)",
  "Item revenue": "إيرادات العناصر",
  "Products, options and extras": "المنتجات والخيارات والإضافات",
  "Tax collected": "الضريبة المُحصّلة",
  "Total discounts given": "إجمالي الخصومات الممنوحة",
  "Cost (COGS)": "التكلفة (تكلفة البضاعة المباعة)",
  "Product cost + delivery cost": "تكلفة المنتج + تكلفة التوصيل",
  "Fees charged for delivery": "الرسوم المُحصّلة مقابل التوصيل",
  "Extra service/handling fees": "رسوم خدمة/مناولة إضافية",
  "Value not yet settled": "قيمة لم تُسوَّ بعد",
  "refunded · excluded from total": "مسترد · مستثنى من الإجمالي",

  // Summary panels
  "Orders by status": "الطلبات حسب الحالة",
  "Where orders stand": "أين تقف الطلبات",
  "Paid vs unpaid": "مدفوع مقابل غير مدفوع",
  "Settled at close vs outstanding": "المُسوّى عند الإغلاق مقابل المستحق",
  "Payment methods": "طرق الدفع",
  "Sales by how customers paid": "المبيعات حسب طريقة دفع العملاء",
  "Sales by source": "المبيعات حسب المصدر",
  "When orders came in": "متى وردت الطلبات",
  "No sales in this window": "لا مبيعات في هذه الفترة",

  // Payments tab
  "What customers were charged across non-refunded orders.":
    "ما تم تحصيله من العملاء عبر الطلبات غير المستردة.",
  "Refunds excluded": "باستثناء المبالغ المستردة",

  // Export + email
  "CSV (current tab)": "CSV (التبويب الحالي)",
  "Excel (all sections)": "إكسل (جميع الأقسام)",
  "Email this closing report daily": "إرسال هذا التقرير الختامي يوميًا",
  Saved: "تم الحفظ",
  "Closing reports are limited to a one-year window.": "تقارير الإغلاق محدودة بفترة سنة واحدة.",
  "Closing reports are limited to the last year.": "تقارير الإغلاق متاحة لآخر سنة فقط.",
};

export default trans;
